import { Badge } from "../ui/badge";
import { Home, Library, UserRound, UsersRound } from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { cn } from "../../lib/utils";
import { useAppStore } from "../../state/app-store";
import { PwaStatus } from "../system/pwa-status";

const navigation = [
  { to: "/", label: "首页", icon: Home },
  { to: "/customers", label: "客户", icon: UsersRound },
  { to: "/resources", label: "资源", icon: Library },
  { to: "/me", label: "我的", icon: UserRound }
];

const titles: Record<string, string> = {
  "/": "今天",
  "/customers": "客户",
  "/resources": "资源",
  "/me": "我的"
};

export function AppShell() {
  const location = useLocation();
  const mode = useAppStore((state) => state.mode);
  const isCustomerWorkspace = location.pathname.startsWith("/customers/");
  const title = isCustomerWorkspace ? "客户工作区" : (titles[location.pathname] ?? "SalesPilot");

  return (
    <div className="mx-auto flex min-h-[var(--app-height,100dvh)] w-full max-w-lg flex-col bg-background text-foreground shadow-[0_0_50px_rgba(15,23,42,0.05)]">
      <PwaStatus />
      {!isCustomerWorkspace ? (
        <header className="sticky top-0 z-30 flex min-h-[calc(60px+env(safe-area-inset-top))] items-end justify-between border-b bg-background/95 px-5 pb-3 pt-[max(12px,env(safe-area-inset-top))] backdrop-blur">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">SalesPilot</p>
            <h1 className="mt-0.5 text-xl font-semibold tracking-tight">{title}</h1>
          </div>
          {mode === "demo" ? <Badge tone="warning">演示模式</Badge> : <Badge tone="success">云端模式</Badge>}
        </header>
      ) : null}

      <div className="min-h-0 flex-1">
        <Outlet />
      </div>

      <nav
        className="fixed inset-x-0 bottom-0 z-40 mx-auto w-full max-w-lg border-t bg-card/96 px-3 pb-[env(safe-area-inset-bottom)] backdrop-blur"
        aria-label="一级导航"
      >
        <div className="grid h-16 grid-cols-4">
          {navigation.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                cn(
                  "flex min-h-11 flex-col items-center justify-center gap-1 rounded-xl text-[11px] font-medium text-muted-foreground transition-colors",
                  isActive && "text-primary"
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span className={cn("grid h-7 w-12 place-items-center rounded-full", isActive && "bg-primary/10")}>
                    <Icon className="size-5" strokeWidth={isActive ? 2.2 : 1.8} aria-hidden="true" />
                  </span>
                  {label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
